// Типы для системы тем TLH.ru

/**
 * Локализованная строка - объект с переводами по языкам
 */
export interface LocalizedString {
  ru: string
  en?: string
  [key: string]: string | undefined
}

/**
 * Значение которое может быть как строкой так и локализованным объектом
 */
export type LocalizableString = string | LocalizedString

export type ThemePreset = 'default' | 'education' | 'corporate' | 'playful' | 'minimal'
export type ThemeMode = 'light' | 'dark' | 'auto'
export type BorderRadius = 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'full'
export type Density = 'compact' | 'comfortable' | 'default'
export type FontSize = 'sm' | 'md' | 'lg'

export interface ThemeColors {
  primary: string
  secondary: string
  accent: string
  background: string
  surface: string
  error: string
  warning: string
  success: string
  info: string
}

export interface GlassSettings {
  blur: number // px
  opacity: number // 0-1
  saturation: number // %
  border: boolean
}

export interface ThemeBranding {
  logo: string // URL или 'text:TLH' для текстового логотипа
  logoDark?: string
  logoCompact?: string // Короткая версия (для мобильных)
  favicon?: string
  appName: LocalizableString // Полное название (локализуемое)
  appNameShort: string // Короткое название (для header)
  tagline?: string // Слоган
  description?: LocalizableString // Описание для страницы about (локализуемое)
}

export interface ThemeTypography {
  fontFamily: string
  fontFamilyHeadings?: string
  fontUrl?: string
  fontSize: FontSize
}

export interface ThemeShape {
  borderRadius: BorderRadius
  density: Density
}

export interface OrgTheme {
  id: string
  name: string
  preset?: ThemePreset
  colors: ThemeColors
  glass: GlassSettings
  branding: ThemeBranding
  typography: ThemeTypography
  shape: ThemeShape
}

// Дефолтные значения
export const defaultGlassSettings: GlassSettings = {
  blur: 20,
  opacity: 0.7,
  saturation: 180,
  border: true,
}

export const defaultColors: ThemeColors = {
  primary: '#15803d', // Deep grass green (green-700)
  secondary: '#166534', // Darker grass green (green-800)
  accent: '#65a30d', // Lime accent (lime-600)
  background: '#0f172a',
  surface: '#1e293b',
  error: '#ef4444',
  warning: '#f59e0b',
  success: '#10b981',
  info: '#3b82f6',
}

export const defaultColorsLight: ThemeColors = {
  primary: '#15803d', // Deep grass green (green-700)
  secondary: '#166534', // Darker grass green (green-800)
  accent: '#65a30d', // Lime accent (lime-600)
  background: '#f8fafc',
  surface: '#ffffff',
  error: '#ef4444',
  warning: '#f59e0b',
  success: '#10b981',
  info: '#3b82f6',
}
